import { AppStartListening } from '.';
import { addFeedCallListenerMiddleware } from '../../apps/feedlotManager/modules/feed/feedCall/listenerMiddlewares/feedCallListenerMiddleware';
import { addManageCommoditiesListeners } from '../../modules/commodities/manageCommodities/listenerMiddlewares/manageCommoditiesListenerMiddleware';
import { isLocalEnvironment } from '../../utils/isLocalEnv';

export const initializeListenerMiddlewares = (
    startAppListening: AppStartListening,
) => {
    addManageCommoditiesListeners(startAppListening);
    addFeedCallListenerMiddleware(startAppListening);

    if (isLocalEnvironment && process.env.NODE_ENV !== 'test') {
        console.log('Listener Middlewares Initialized');
    }
};
